module.exports = __webpack_public_path__ + "static/media/DataSearch_31.f6a883ab.webp";